import clsx from "clsx";
import React, { useRef } from "react";

export function IdTooltip({ id, className = null }) {
  const isPreview =
    process.env.GATSBY_CONTENTFUL_HOST?.startsWith("preview") ?? false;
  const inputRef = useRef(null);

  const selectAll = (e) => {
    e.target.select();
  };

  if (!isPreview) return null;
  return (
    <div
      onClick={() => inputRef.current.click()}
      className={clsx(
        "absolute z-10 -mt-9  mx-3 opacity-30 hover:opacity-100 flex gap-2 text-xxs text-invert outline-dashed",
        "outline-1 outline-offset-4 outline-invert hover:outline-double items-center",
        className,
      )}
    >
      <label htmlFor={id}>hash:</label>
      <input
        ref={inputRef}
        name={id}
        value={`#${id}`}
        readOnly
        className="bg-transparent w-[150px] py-1"
        onClick={selectAll}
      />
    </div>
  );
}
